/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./tailwind-output.css";

const elem = document.getElementById("root")!;
createRoot(elem).render(
  <StrictMode>
    <App />
  </StrictMode>
);
